export default "__VITE_ASSET__CLAGVO6D__"